var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('v-divider', {
    staticClass: "mb-4"
  }), !_vm.hideTitle ? [_c('p', {
    staticClass: "px-4 title primary--text"
  }, [_vm._v(_vm._s(_vm.$t('Related Names')))])] : _vm._e(), _vm._l(_vm.related, function (item) {
    return item.items.length ? _c('div', {
      key: "named-related-".concat(_vm.id, "-").concat(item.name)
    }, [_c('p', {
      staticClass: "px-4 subtitle-1"
    }, [_vm._v(_vm._s(item.name))]), _c('Scroller', {
      attrs: {
        "icon": _vm.$size(64)
      }
    }, [_vm._l(item.items, function (named) {
      return _c('div', {
        key: "named-related-".concat(_vm.id, "-").concat(item.name, "-").concat(named.m_NamedType),
        staticClass: "ml-4",
        style: {
          width: _vm.$size(64) + 'px'
        }
      }, [_c('router-link', {
        attrs: {
          "to": "/named/".concat(named.m_NamedType)
        }
      }, [_c('CharaIcon', {
        attrs: {
          "named": "",
          "id": named.m_NamedType,
          "size": _vm.$size(64)
        }
      }), _c('div', {
        staticClass: "caption text-center two-lines"
      }, [_vm._v(_vm._s(_vm.$name(named.fullName)))])], 1)], 1);
    }), _c('div', {
      staticClass: "pl-4"
    })], 2)], 1) : _vm._e();
  })], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }